import type { TranslationDict } from './ja'

export const ru: TranslationDict = {
  appTitle: 'Lucky Animal Territory',
  help: 'Как играть',
  helpAria: 'Как играть',
  settings: 'Настройки',
  settingsAria: 'Настройки',
  close: 'Закрыть',
  closeAria: 'Закрыть',
  player: 'Игрок',
  highscore: 'Рекорд',
  start: 'Начать игру',
  staminaEmpty: 'Недостаточно выносливости',
  ranking: 'Битва за территорию',
  difficultyTitle: 'Выберите сложность',
  difficultyStart: 'Начать с этой сложностью',
  back: 'Назад',
  today: 'Сегодня',
  weekly: 'Эта неделя',
  alltime: 'За всё время',
  loading: 'Загрузка...',
  noScores: 'Пока нет результатов. Станьте первым чемпионом!',
  loadFailed: 'Не удалось загрузить',
  you: 'Вы',
  youConstant: 'ВЫ',
  language: 'Язык',
  languageNote: 'Поддерживает 18 языков, включая японский.',
  bgm: 'Музыка',
  se: 'Звуковые эффекты',
  soundEnableAria: 'Включить звук',
  soundDisableAria: 'Выключить звук',
  adWatch: 'Смотреть рекламу до конца',
  adCancel: 'Не сейчас',
  rankSuffix: '-е место',
  earnedPoints: 'получил {score} очков',
  helpGoalTitle: '🎯 Цель игры',
  helpGoalText: 'Размещайте фишки на поле 9x9 и расширяйте свои территории. Побеждает игрок с наибольшим количеством очков.',
  helpWinTitle: '🏆 Условия победы',
  helpWinFive: 'Соберите пять фишек своего цвета в ряд (вертикально, горизонтально или по диагонали) для мгновенной победы.',
  helpWinScore: 'Если поле заполнится, победа присуждается по количеству очков. Ничьих не бывает.',
  helpScoreTitle: '💯 Начисление очков',
  helpLineBonus: 'Линейный бонус: получайте очки за линии из 3, 4 и 5 фишек.',
  helpClusterBonus: 'Бонус за территорию: чем больше группа соединенных фишек, тем больше очков вы получите.',
  helpKomi: 'Коми: второй игрок получает бонус +10% к очкам для баланса.',
  helpControlsTitle: '🖱️ Управление',
  helpControlsText: 'В свой ход нажмите на пустую клетку, чтобы поставить фишку.',
  helpTipsTitle: '💡 Советы',
  helpTipHell: 'Попробуйте сложность HELL, если ищете настоящий вызов.',
  helpTipCluster: 'Не гонитесь только за пятеркой в ряд. Большие группы соединенных фишек также значительно увеличивают ваш счет.',
  resultWinFive: '🎉 Пять в ряд! Вы победили!',
  resultWinScore: '🎉 Победа по очкам! Вы победили!',
  resultLoseFive: '😿 CPU собрал пять в ряд!',
  resultLoseScore: '😿 Проигрыш по очкам. Попробуйте еще раз!',
  resultDraw: '🤝 Ничья',
  newHighscore: '🏆 Новый рекорд!',
  scoreNone: 'Нет счета',
  clusterBonus: 'Бонус за территорию',
  retry: 'Играть снова',
  titleBack: 'В меню',
  scoreHintPlaceStone: 'Поставьте камень',
  best: 'Лучший',
  clusterUnit: 'группа',
  lineCount: '{len} в ряд x{count}',
  turnCount: 'Ход {count} · {difficulty}',
  boardPlayerPiece: 'Ваша фишка',
  boardCpuPiece: 'Фишка CPU',
  boardPlayerAlt: 'Вы',
  boardCpuAlt: 'CPU',
  boardCellPosition: 'ряд {row}, столбец {col}',
  boardPlaceable: 'можно поставить',
  boardEmpty: 'пустая клетка',
  boardFlower: 'с цветком',
  firstPlayerAlt: 'Первый игрок',
  playerFirst: 'Вы ходите первым!',
  playerSecond: 'Вы ходите вторым (+{bonus}% коми)',
  cpuFirst: 'CPU ходит первым!',
  finalePlayerWin: 'Вы победили!',
  finaleCpuWin: 'CPU победил!',
  finaleFive: 'Пять в ряд!',
  finaleTerritory: 'Битва территорий!',
  winnerAlt: 'Победитель',
  loadingBoot: 'Запуск...',
  loadingConnect: 'Соединение...',
  loadingProfile: 'Загрузка профиля...',
  loadingAssets: 'Загрузка ресурсов...',
  loadingReady: 'Готово',
  reauthRequiredTitle: 'Требуется вход',
  startupFailedTitle: 'Ошибка запуска',
  reauthButton: 'Войти снова',
  reloadButton: 'Перезагрузить',
  lineReloginButton: 'Вход через LINE',
  reauthReason: 'Ваш сеанс истек. Пожалуйста, войдите снова.',
  errorReauth: 'Ваш сеанс истек. Пожалуйста, войдите снова.',
  errorForbidden: 'У вас нет разрешения на доступ к этой игре.',
  errorNotFound: 'Данные игры не найдены.',
  errorRateLimited: 'Сеть перегружена. Пожалуйста, подождите и попробуйте снова.',
  errorServer: 'Не удалось подключиться к серверу. Пожалуйста, подождите и перезагрузите страницу.',
  errorCommunication: 'Ошибка связи. Пожалуйста, перезагрузите страницу.',
  errorNetwork: 'Не удалось подключиться к сети. Проверьте соединение и перезагрузите страницу.',
  errorStartup: 'Ошибка запуска. Пожалуйста, перезагрузите страницу.',
  settingsTabGeneral: 'Настройки',
  settingsTabAccount: 'Аккаунт',
  settingsTabInfo: 'Инфо',
  account: 'Аккаунт',
  linked: 'Связано',
  guest: 'Гость',
  loggedInWith: 'Вход через {provider}',
  loggedIn: 'Вы вошли',
  playingAsGuest: 'Вы играете как гость.',
  appleLoginBusy: 'Вход через Apple...',
  appleLogin: 'Войти через Apple',
  googleLoginBusy: 'Вход через Google...',
  googleLogin: 'Войти через Google',
  logoutBusy: 'Выход...',
  logout: 'Выйти',
  logoutSuccess: 'Вы вышли',
  logoutFailed: 'Ошибка выхода',
  appInfo: 'О приложении',
  appName: 'Название приложения',
  version: 'Версия',
  legalInfo: 'Юридическая информация',
  terms: 'Условия использования',
  privacy: 'Политика конфиденциальности',
  operator: 'Оператор',
  contact: 'Контакты',
  copyTap: 'Нажмите, чтобы скопировать',
  idCopied: 'ID скопирован',
  copyFailed: 'Ошибка копирования',
  other: 'Прочее',
  reportAd: 'Пожаловаться на рекламу',
  privacyChoices: 'Ad privacy choices',
  profileEdit: 'Изменить профиль',
  displayName: 'Имя пользователя',
  displayNamePlaceholder: 'Введите имя',
  chooseIcon: 'Выбрать иконку',
  iconLoadFailed: 'Не удалось загрузить иконки.',
  saveFailed: 'Ошибка сохранения. Попробуйте еще раз.',
  noIcons: 'Нет доступных иконок.',
  save: 'Сохранить',
  saving: 'Сохранение...',
  staminaAria: 'Выносливость {stamina} / {max}',
  nextRecovery: 'Восстановление через {time}',
  adPlaying: 'Воспроизведение рекламы...',
  recoverFullAd: 'Посмотрите рекламу, чтобы полностью восстановить выносливость',
  dailyBonusAria: 'Посмотреть рекламу до конца за +5 выносливости',
  dailyBonusAd: 'Посмотрите рекламу за +5 выносливости',
  legalLastUpdated: 'Последнее обновление: {date}',
  privacyTitle: 'Политика конфиденциальности',
  termsTitle: 'Условия использования',
  adPlayingAria: 'Идет реклама',
  adBadge: '▶ Реклама',
  adRemaining: 'Осталось {seconds} сек.',
  adDevHint: 'Тестовая реклама. В финальной версии будет реклама AdMob.',
  adRewardRequirement: 'Посмотрите рекламу до конца, чтобы получить эту награду.',
  adRewardStaminaDetail: 'Награда: восстановить выносливость до максимума',
  adRewardDailyBonusDetail: 'Награда: +{amount} выносливости как ежедневный бонус',
  adRewardIncompleteNote: 'Если закрыть раньше, награда не будет получена.',
  adSkipAria: 'Пропустить рекламу',
  adSkip: 'Пропустить ✕',
  adSkipAfter: 'Пропуск через {seconds} сек.',
  offlineMessage: 'Не удается подключиться к серверу. Некоторые функции могут быть недоступны.',
  reconnecting: 'Переподключение...',
  reconnect: 'Подключиться снова',
  signInTitle: 'Вход',
  signInBusy: 'Вход...',
  signInCancelNote: 'Если вы отмените вход, вы сможете продолжить игру как гость (некоторые функции будут ограничены).',
  processing: 'Обработка...',
  recoverConfirmTitle: 'Подтвердите замену данных',
  recoverConfirmMessage: 'С этим входом уже связаны существующие данные. Продолжение приведет к замене гостевых данных на этом устройстве. Продолжить?',
  recoverConfirmContinue: 'Восстановить',
  recoverConfirmCancel: 'Отмена',
  unlinkConfirmTitle: 'Отвязать аккаунт',
  unlinkConfirmMessage: 'Если вы отвяжете аккаунт от этого провайдера, устройство вернется в гостевой режим. Ваши данные в Hub останутся доступны, если вы снова войдете через того же провайдера на другом устройстве.',
  unlinkConfirmContinue: 'Отвязать',
  unlinkConfirmCancel: 'Отмена',
  deleteConfirmTitle: 'Подтвердите удаление аккаунта',
  deleteConfirmMessage: 'Удаление аккаунта приведет к удалению всех рекордов, данных входа, привязанных аккаунтов и приглашений.\nЭто действие нельзя отменить. Вы уверены, что хотите удалить аккаунт?',
  deleteConfirmContinue: 'Удалить аккаунт',
  deleteConfirmCancel: 'Отмена',
  adNekoTitle: 'Рекламный кот',
  matchmakingRemaining: 'Осталось {seconds} сек.',
  matchmakingTimeoutMessage: 'Противник не найден. Пожалуйста, попробуйте еще раз.',
  difficultyEasyName: 'Легко',
  difficultyEasyDescription: 'Противник немного рассеян',
  difficultyNormalName: 'Нормально',
  difficultyNormalDescription: 'Противник иногда ошибается',
  difficultyHardName: 'Сложно',
  difficultyHardDescription: 'Противник хорошо видит поле',
  difficultyHellName: 'Ад',
  difficultyHellDescription: 'Противник очень силен и просчитывает ходы наперед',
}
